module.exports = __webpack_public_path__ + "static/media/no_result_x2.777b8f7b.png";